import { View } from 'api/views/types';
import {
  Loaded,
  Creating,
  Updating,
  Deleting,
  Empty,
  Loading,
} from 'core/state';

export type CreatableView<ViewDefinition> = Omit<
  View<ViewDefinition>,
  'viewId' | 'createdBy' | 'viewType'
>;

export type ManageableView<ViewDefinition> =
  | Loaded<View<ViewDefinition>>
  | Creating<View<ViewDefinition>>
  | Updating<View<ViewDefinition>>
  | Deleting<View<ViewDefinition>>;
export type NonDeletedView<ViewDefinition> = Exclude<
  ManageableView<ViewDefinition>,
  Deleting<View<ViewDefinition>>
>;
export interface Views<ViewDefinition> {
  byIds: Record<
    number,
    | Loaded<View<ViewDefinition>>
    | Creating<View<ViewDefinition>>
    | Updating<View<ViewDefinition>>
    | Deleting<View<ViewDefinition>>
  >;
  ids: Empty | Loading | Loaded<number[]>;
}

export enum FieldType {
  Native = 'NATIVE',
  Custom = 'CUSTOM',
}

interface CustomFieldGroup {
  fieldId: number;
  fieldClass: FieldType.Custom;
}

interface NativeFieldGroup {
  name: string;
  fieldClass: FieldType.Native;
}
export type FieldGroup = CustomFieldGroup | NativeFieldGroup;
